{
  "close": "Zatvori",
  "notifications": "Obavijesti"
}
